module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image15e.73ca36ac.jpg";